module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_05@1.aad4ea49.png";